<style lang="sass">

    @import ../../common/styles/settings
    @import ../../common/styles/mixins

    .row--overlay
        margin-top: -$baseline*8

        +media('<=xsmall')
            margin-bottom: $baseline*2

        //&:first-child
            .body--column
                +media('<=xsmall')
                    padding-bottom: 0

        > * + *
            .body--column
                +media('<=xsmall')
                    margin-top: $baseline


    .body
        background-color: white
        &__row.row
            margin-left: -.625rem
            margin-right: -.625rem
        &__section
            text-align: center
        &__content
            margin-bottom: $baseline*2

            > *
                margin: 0
                + *,
                + .title
                    margin-top: $baseline

        header
            margin-bottom: $baseline*1.5
            padding-bottom: $baseline*1.5
            border-bottom: 1px solid $color-border

        ul
            padding-left: 0
            margin-top: $baseline
            margin-left: 1em
            font-size: 1rem
            font-weight: 400
            line-height: 1.375

        .title--3
            font-size: 1.375rem
            color: $color-side


        &--column.card
            display: flex
            flex-direction: column
            height: 100%
            padding: $baseline*2
            text-align: left
            > .locatorfirst
                background-color: $color-background-light
                padding-top: 0
                +media('<=medium')
                    padding: 0 $baseline*2 $baseline*2
                & > .locator
                    margin-top: -1rem
                    background: none
                    //position: relative
                    //z-index: 2
                & > .card
                    margin-top: -4rem
                    //position: relative
                    //z-index: 1
                    +media('<=medium')
                        margin-top: 1rem
                        margin-bottom: 2rem

                & > .widget .search-form .search-geolocation-button:first-child
                    margin-left: 0

            .list
                margin-top: auto
                margin-bottom: 0
                padding-top: $baseline*1.5

            .title
                &--2
                    text-align: left
                &--3
                    margin-top: $baseline
                &--lined
                    +media('>xsmall')
                        margin-right: $baseline*-2
                        margin-left: $baseline*-2

        // TODO: apply on row / simplify selector
        &--overlay

            .title--2
                // TODO: refactor
                .section &
                    +media("<=small")
                        text-align: left

    .plus
        font-size: .75rem
        font-weight: 400
        line-height: 1.83

        img
            display: block
            max-width: 75%
            margin: 0 auto $baseline
            height: auto

            +media('>xsmall')
                margin-bottom: $baseline*.5
                max-width: 100%
    .page--find__columns
        &__row
            align-items: flex-start
    .page--find
        .breadcrumbs__wrapper
            margin-top: 50px


</style>

<script>
    import Locator from '../../common/components/locator/Locator.vue'
    import Newsfeed from '../../common/components/Newsfeed.vue'

    export default {
        components: {
            Locator,
            Newsfeed
        }
    }
</script>
